// extracted by mini-css-extract-plugin
export default {"container":"sCwo","header":"V8WC","content":"Fujp","actions":"x1Su","btn":"rtgl","red":"Kbcy","blue":"TXD2"};